module.exports = __webpack_public_path__ + "static/cosyelephant1-d2c8b474bbce088d4cda6d8a7a6f2fc8.png";